<template>
  <div id="serverError" class="form" :class="$mq">
    <div :class="$mq" class="section">
      <p v-html="$t('unavailable')"></p>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {
  }
};
</script>

<style lang="scss" scoped>
.section {
  margin: 10px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/Unavailable.vue